<template>
  <el-card>
    <div slot="header" class="header">
      <h4>{{ formData.name }}</h4>
      <el-button size="small" type="primary" @click="$router.push('recipeList?code=' + $route.query.code)">{{$t('lang.选择菜谱')}}</el-button>
      <el-button size="small" type="primary" @click="handleBatchDelete">{{$t('lang.批量删除')}}</el-button>
    </div>

    <fb-list-body :pager="pager"
                  :showSearchForm="false"
                  :showBtnGroup="false"
                  :showPager="false"
                  @handlePagerSizeChange="handlePagerSizeChange"
                  @handlePagerIndexChange="handlePagerIndexChange">

      <template slot="table">
        <el-table :data="tableData" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column type="index" :label="$t('lang.序号')"></el-table-column>
          <el-table-column prop="name" :label="$t('lang.图片')">
            <template v-slot="{row}">
              <el-image style="width: 100px; height: 100px" :src="row.photo | filterImg" />
            </template>
          </el-table-column>
          <el-table-column prop="name" :label="$t('lang.食谱名称')"></el-table-column>
          <el-table-column prop="number" :label="$t('lang.食谱编号')"></el-table-column>
          <el-table-column label="">
            <template v-slot="{row}">
              <nation-list :high-light="row.confirmLangList" :list="row.supportLangList" disabled />
            </template>
          </el-table-column>
          <el-table-column :label="$t('lang.操作')">
            <template v-slot="{row}">
              <el-button type="primary" size="small" @click="handleDelete(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>

    </fb-list-body>

  </el-card>
</template>

<script>
import NationList from "../../components/nation/NationList";
export default {
  name: "OnlineCateDetail",
  components: {NationList},
  data() {
    return {
      api: {
        list: this.$api.recipe.list,
        deleteRefRecipe: this.$api.appOnlineCategory.batchDeleteByRecipe,
      },
      formData: {},
      tableData: [],
      pager: {},
      selection: []
    }
  },
  methods: {
    handleBatchDelete() {
      let vm = this;
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: vm.$t('lang.未选择记录')
        });
        return;
      }
      let codes = this.selection.map(item => item.code);
      this.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {
        vm.$http.post(this.api.deleteRefRecipe, codes).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleSearch();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })
      }).catch(() => {});
    },

    handleDelete(row) {
      let vm = this;
      vm.$confirm(vm.$t(`lang.您现在正在进行删除操作`), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {
        vm.$http.post(vm.api.deleteRefRecipe, [row.code]).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleSearch();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })
      }).catch(() => {});

    },

    handleSelectionChange(selection) {
      this.selection = selection;
    },

    handlePagerSizeChange(e) {
      this.pager.pageSize = e;
    },
    handlePagerIndexChange(e) {
      this.pager.pageIndex = e;
    },

    handleSearch() {
      let vm = this;
      let data = {
        refAppOnlineCategory: this.$route.query.code,
        status: "released",
        brandOwnerCode: this.$store.state.userInfo['brandOwnerCode'],
        ...this.searchParams,
        onPage: false,
      };
      delete data.code;
      this.$http.post(this.api.list, this.$qs.stringify(data)).then((resp) => {
        for (let key in resp.data.data) {
          if (resp.data.data[key] instanceof Array) {
            vm.tableData = resp.data.data[key];
          }
        }
      })
    }
  },
  created() {
    // this.handleLoadDetail();
    this.formData = this.$route.query;
    this.handleSearch();
  }
}
</script>

<style scoped>
  .el-form {
    width: 500px;
  }

  h4 {
    padding: 0;
    margin: 0;
  }

  .header {
    display: flex;
    align-items: center;
    column-gap: 26px;
  }

</style>